import React from "react";

import "./styles/modal-content-remove.scss";

interface Props {
  text?: string;
}

function ModalContentRemove({ text }: Props) {
  const message = text ? text : 'Вы уверены, что хотите удалить?';

  return (
    <div className="modal-content-remove">
      <p className="modal-content-remove__text">
        { message }
      </p>
    </div>
  );
}

export default ModalContentRemove;
